/**
 * Stock Movement Actions
 * Gère les mouvements de stock enrichis avec traçabilité IN/OUT
 */

import * as stocksAPI from '../api/stocksAPI';

// Action Types
export const FETCH_STOCK_MOVEMENTS_START = "FETCH_STOCK_MOVEMENTS_START";
export const FETCH_STOCK_MOVEMENTS_SUCCESS = "FETCH_STOCK_MOVEMENTS_SUCCESS";
export const FETCH_STOCK_MOVEMENTS_ERROR = "FETCH_STOCK_MOVEMENTS_ERROR";

export const FETCH_STOCK_HISTORY_START = "FETCH_STOCK_HISTORY_START";
export const FETCH_STOCK_HISTORY_SUCCESS = "FETCH_STOCK_HISTORY_SUCCESS";
export const FETCH_STOCK_HISTORY_ERROR = "FETCH_STOCK_HISTORY_ERROR";

export const SET_STOCK_VIEW_MODE = "SET_STOCK_VIEW_MODE";
export const CLEAR_STOCK_MOVEMENTS = "CLEAR_STOCK_MOVEMENTS";

/**
 * Récupère les mouvements de stock enrichis depuis la nouvelle API
 * @param {string} shopId - ID du shop
 * @param {string} productId - ID du produit
 * @returns {function} Thunk action
 */
export function fetchStockMovements(shopId, productId) {
    console.log("FIRED ACTION FETCH STOCK MOVEMENTS", { shopId, productId });
    
    return async function(dispatch) {
        dispatch({
            type: FETCH_STOCK_MOVEMENTS_START,
            payload: { shopId, productId }
        });
        
        try {
            const data = await stocksAPI.getStockMovements(shopId, productId);
            
            console.log('==============fetchStockMovements======================');
            console.log({ data });
            console.log('====================================');
            
            if (data && data.movements) {
                dispatch({
                    type: FETCH_STOCK_MOVEMENTS_SUCCESS,
                    payload: {
                        shopId,
                        productId,
                        movements: data.movements,
                        currentStock: data.current_stock,
                        totalMovements: data.total_movements,
                        ignoredMovements: data.ignored_movements || [],
                        totalHistories: data.total_histories || 0,
                        totalIgnored: data.total_ignored || 0
                    }
                });
                
                // Logger les mouvements ignorés si présents
                if (data.ignored_movements && data.ignored_movements.length > 0) {
                    console.warn(`[WARNING] ${data.total_ignored} mouvement(s) ignoré(s):`, data.ignored_movements);
                }
                
                return data.movements;
            } else {
                const error = data.error || "Aucun mouvement trouvé";
                dispatch({
                    type: FETCH_STOCK_MOVEMENTS_ERROR,
                    payload: { shopId, productId, error }
                });
                return [];
            }
            
        } catch (err) {
            console.error('[ERROR] fetchStockMovements', err);
            dispatch({
                type: FETCH_STOCK_MOVEMENTS_ERROR,
                payload: { 
                    shopId, 
                    productId, 
                    error: err.message || "Erreur lors de la récupération des mouvements" 
                }
            });
            return [];
        }
    };
}

/**
 * Définit le mode d'affichage (enhanced ou classic)
 * @param {string} mode - "enhanced" ou "classic"
 * @returns {object} Action
 */
export function setStockViewMode(mode) {
    // Sauvegarder dans localStorage
    localStorage.setItem('stock_history_view_preference', mode);
    
    return {
        type: SET_STOCK_VIEW_MODE,
        payload: mode
    };
}

/**
 * Bascule entre les modes d'affichage
 * @returns {function} Thunk action
 */
export function toggleStockViewMode() {
    return (dispatch, getState) => {
        const currentMode = getState().stockMovements?.viewMode || 'classic';
        const newMode = currentMode === 'enhanced' ? 'classic' : 'enhanced';
        dispatch(setStockViewMode(newMode));
    };
}

/**
 * Efface les mouvements de stock du store
 * @returns {object} Action
 */
export function clearStockMovements() {
    return {
        type: CLEAR_STOCK_MOVEMENTS
    };
}

/**
 * Récupère l'historique de stock classique (API existante)
 * @param {string} stockID - Format "shop_id|product_id"
 * @returns {function} Thunk action
 */
export function fetchStockHistory(stockID) {
    console.log("FIRED ACTION FETCH STOCK HISTORY", stockID);
    
    return async function(dispatch) {
        dispatch({
            type: FETCH_STOCK_HISTORY_START,
            payload: stockID
        });
        
        try {
            const list = await stocksAPI.getStockHistory(stockID);
            
            dispatch({
                type: FETCH_STOCK_HISTORY_SUCCESS,
                payload: { stockID, history: list }
            });
            return list;
            
        } catch (err) {
            console.error('[ERROR] fetchStockHistory', err);
            dispatch({
                type: FETCH_STOCK_HISTORY_ERROR,
                payload: { stockID, error: err.message }
            });
            return [];
        }
    };
}

